module.exports = __webpack_public_path__ + "assets/arrow_back.52e27c68.svg";